import axios from 'axios';
import { req } from './axiosFun';

export const lineList = (params) => { return axios.get("admin/line/list?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const lineScDetails = (params) => { return axios.get("admin/line/list/scDetails") };
export const deleteById = (params) => { return req("post", "admin/line/delete", params) };
export const lineEdit = (params) => { return req("post", "admin/line/edit", params) };
export const lineSave = (params) => {
    // 将 params 对象转换为 JSON 字符串
    const jsonData = JSON.stringify(params);

    // 发送 POST 请求的 URL
    const url = "admin/line/save";

    // 发送 POST 请求
    return axios.post(url, jsonData, {
        headers: {
            'Content-Type': 'application/json' // 告诉服务器发送的是 JSON 数据
        }
    })
};


// WEBPACK FOOTER //
// ./src/api/linesMG.js